var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collection-mobile-menu",
      class: { "menu-active": _vm.menuActive }
    },
    [
      _c(
        "div",
        { staticClass: "collection-mobile-menu__header" },
        [
          _c("div", { staticClass: "collection-mobile-menu__header-title" }, [
            _c("h4", [_vm._v(_vm._s(_vm.menuTitle))])
          ]),
          _c("icon", {
            staticClass: "collection-mobile-menu__header-close",
            attrs: { name: "close", size: "24px" },
            on: { click: _vm.closeBinding }
          })
        ],
        1
      ),
      _c("vue100vh", { staticClass: "collection-mobile-menu__container" }, [
        _c(
          "div",
          { staticClass: "collection-mobile-menu__contents" },
          [_vm._t("default")],
          2
        ),
        _c(
          "div",
          { staticClass: "collection-mobile-menu__apply-button" },
          [
            _vm.enableApplyButton
              ? _c("v-button", {
                  attrs: { primary: true, full: true, label: "APPLY" },
                  on: { click: _vm.closeBinding }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }